import React, { useEffect, useReducer, useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { CardBody, Table } from "reactstrap";
import newId from "../../../newid";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { Card, Col, Container, Row, Input, Label, Form } from "reactstrap";
import {
  useArticle,
  useArticleCategories,
  useDeleteParagraph,
  useUpdateArticle,
} from "../../../hooks/useArticles";

const reducer = (state, action) => {
  switch (action.type) {
    case "ADD_ITEM": {
      return { ...state, itemlist: [...state.itemlist, action.payload] };
    }
    case "REMOVE_ITEM": {
      const newItemListR = state.itemlist.filter(
        (item) => item.id !== action.payload.id
      );
      return { ...state, itemlist: newItemListR };
    }

    case "UPDATE_SUBTITLE": {
      const newItem = action.payload;
      const existItem = state.itemlist.find((item) => item.id === newItem.id);
      const newItemList = existItem
        ? state.itemlist.map((item) =>
            item.id === existItem.id ? newItem : item
          )
        : [...state.itemlist, newItem];
      return { ...state, itemlist: newItemList };
    }

    case "UPDATE_PHOTO": {
      const newItem = action.payload;
      const existItem = state.itemlist.find((item) => item.id === newItem.id);
      const newItemList = existItem
        ? state.itemlist.map((item) =>
            item.id === existItem.id ? newItem : item
          )
        : [...state.itemlist, newItem];
      return { ...state, itemlist: newItemList };
    }

    case "UPDATE_CONTENT": {
      const newItem = action.payload;
      const existItem = state.itemlist.find((item) => item.id === newItem.id);
      const newItemList = existItem
        ? state.itemlist.map((item) =>
            item.id === existItem.id ? newItem : item
          )
        : [...state.itemlist, newItem];
      return { ...state, itemlist: newItemList };
    }

    default:
      return state;
  }
};

const ArticlesUpdate = (props) => {
  const { id } = useParams();
  const history = useHistory();
  const { data: article, isLoading, error } = useArticle(id);
  const { data: categoryList = [] } = useArticleCategories();
  const updateArticleMutation = useUpdateArticle();
  const deleteParagraphMutation = useDeleteParagraph();
  const [formState, setFormState] = useState({
    title: "",
    category: "",
    paragraphs: [],
  });

  const [state, invDispatch] = useReducer(reducer, {
    itemlist: [],
  });
  const { itemlist } = state;

  useEffect(() => {
    if (!article) {
      return;
    }

    setFormState({
      title: article.title || "",
      category: article.category || "",
      paragraphs: article.paragraphs || [],
    });
  }, [article]);

  const addItem = () => {
    invDispatch({
      type: "ADD_ITEM",
      payload: {
        id: newId(),
        subtitle: "",
        content: "",
        paragraph_pic: null,
        article: article?.id,
      },
    });
  };

  const removeItemInLocal = (item) => {
    invDispatch({
      type: "REMOVE_ITEM",
      payload: item,
    });
  };

  const removeItem = (paragraphId) => {
    deleteParagraphMutation.mutate(
      { paragraphId, articleId: article?.id },
      {
        onSuccess: () => {
          setFormState((current) => ({
            ...current,
            paragraphs: current.paragraphs.filter(
              (paragraph) => String(paragraph.id) !== String(paragraphId)
            ),
          }));
        },
      }
    );
  };

  const updateExistingParagraph = (paragraphId, field, value) => {
    setFormState((current) => ({
      ...current,
      paragraphs: current.paragraphs.map((paragraph) =>
        String(paragraph.id) === String(paragraphId)
          ? { ...paragraph, [field]: value }
          : paragraph
      ),
    }));
  };

  const updateSubtitleHandler = async (item, subtitle) => {
    invDispatch({
      type: "UPDATE_SUBTITLE",
      payload: { ...item, subtitle },
    });
  };

  const updateContentHandler = async (item, content) => {
    invDispatch({
      type: "UPDATE_CONTENT",
      payload: { ...item, content },
    });
  };

  const updatePhotoHandler = async (item, paragraph_pic) => {
    invDispatch({
      type: "UPDATE_PHOTO",
      payload: { ...item, paragraph_pic },
    });
  };

  document.title = props.t("Modifier article | Le Conseiller du BTP");
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!formState.title) {
      newErrors.title = "Ce champ est requis";
    }

    if (!formState.category) {
      newErrors.category = "Ce champ est requis";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (validate()) {
      const payload = {
        title: formState.title,
        category_id: formState.category,
        paragraphs: [
          ...formState.paragraphs,
          ...itemlist.filter(
            (item) => item.subtitle || item.content || item.paragraph_pic
          ),
        ],
      };

      updateArticleMutation.mutate(
        { articleId: article?.id, payload },
        {
          onSuccess: () => {
            history.push("/articles");
          },
        }
      );
    }
  };


  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={props.t("Modifier article")}
          pageTitle={props.t("Articles")}
        />
        <Row className="justify-content-center">
          <Col xxl={12}>
            <Card>
              <Form encType="mutipart/form-data" onSubmit={submitHandler}>
                <CardBody className="p-4">
                  {isLoading ? (
                    <div className="py-4 text-center">
                      <div className="mt-4">
                        <h5>{props.t("Chargement")}...</h5>
                      </div>
                    </div>
                  ) : error ? (
                    <div className="py-4 text-center">
                      <div className="mt-4">
                        <h5>{error.message || props.t("Une erreur est survenue")}</h5>
                      </div>
                    </div>
                  ) : (
                    <>
                      <Row>
                        <Col xl={12}>
                          <div className="mb-3">
                            <Label className="form-label">
                              {props.t("TITRE")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form"
                              name="title"
                              value={formState.title}
                              onChange={(event) =>
                                setFormState((current) => ({
                                  ...current,
                                  title: event.target.value,
                                }))
                              }
                            />
                            {errors.title && (
                              <p className="text-danger">{props.t(errors.title)}</p>
                            )}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xl={12}>
                          <div className="mb-3">
                            <Label className="form-label">
                              {props.t("CATEGORIE")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </Label>
                            <Input
                              className="form-control"
                              value={formState.category}
                              name="category"
                              type="select"
                              onChange={(event) =>
                                setFormState((current) => ({
                                  ...current,
                                  category: event.target.value,
                                }))
                              }
                            >
                              <option value="">
                                Sélectionner une catégorie d'articles
                              </option>
                              {categoryList.map((item) => (
                                <option value={item.id} key={item.id}>
                                  {item.designation}
                                </option>
                              ))}
                            </Input>
                            {errors.category && (
                              <p className="text-danger">{props.t(errors.category)}</p>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </>
                  )}
                </CardBody>

                <CardBody className="p-4">
                  <div className="table-responsive">
                    <Table className="invoice-table table table-borderless mb-0">
                      <thead className="align-middle">
                        <tr className="table-active">
                          <th scope="col" style={{ width: "25%" }}>
                            {props.t("SOUS TITRE")}{" "}
                            <span className="text-danger">*</span>
                          </th>

                          <th scope="col" style={{ width: "50%" }}>
                            {props.t("CONTENU")}{" "}
                            <span className="text-danger">*</span>
                          </th>

                          <th scope="col" style={{ width: "30%" }}>
                            {props.t("IMAGE")}{" "}
                            <span className="text-danger">*</span>
                          </th>
                        </tr>
                      </thead>

                      {(formState.paragraphs || []).map((item) => {
                        return (
                          <React.Fragment key={item.id}>
                            <tbody name={"paragraphs"} key={item.id}>
                              <tr id={item.id} className="product">
                                <td className="text-start">
                                  <div className="mb-2">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      value={item.subtitle || ""}
                                      name={`paragraphs[${item.id}].subtitle`}
                                      onChange={(event) =>
                                        updateExistingParagraph(
                                          item.id,
                                          "subtitle",
                                          event.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </td>
                                <td>
                                  <textarea
                                    className="form-control"
                                    name={`paragraphs[${item.id}].content`}
                                    value={item.content || ""}
                                    onChange={(event) =>
                                      updateExistingParagraph(
                                        item.id,
                                        "content",
                                        event.target.value
                                      )
                                    }
                                    rows="10"
                                    cols="20"
                                  />
                                </td>
                                <td>
                                  <Input
                                    type="file"
                                    className="form-control"
                                    name={`paragraphs[${item.id}].paragraph_pic`}
                                    accept="image/jpeg,image/png,image/webp"
                                    capture="file"
                                    onChange={(event) =>
                                      updateExistingParagraph(
                                        item.id,
                                        "paragraph_pic",
                                        event.target.files[0] || null
                                      )
                                    }
                                  />
                                  <br />
                                  {item.paragraph_pic ? (
                                    <img
                                      src={
                                        item.paragraph_pic instanceof File
                                          ? URL.createObjectURL(item.paragraph_pic)
                                          : item.paragraph_pic
                                      }
                                      style={{ maxWidth: "50%" }}
                                      alt="Thumbnail"
                                    />
                                  ) : (
                                    "Pas d'image"
                                  )}
                                </td>
                                <td
                                  id={`product-removal-${item.id}`}
                                  className="product-removal"
                                >
                                  <Link
                                    id={`del-${item.id}`}
                                    to="#"
                                    className="btn btn-danger"
                                    onClick={() => {
                                      removeItem(item.id);
                                    }}
                                  >
                                    {props.t("Supprimer")}
                                  </Link>
                                </td>
                              </tr>
                            </tbody>
                          </React.Fragment>
                        );
                      })}
                      {itemlist.map((item) => {
                        return (
                          <React.Fragment key={item.id}>
                            <tbody name={"paragraphs"} key={item.id}>
                              <tr id={item.id} className="product">
                                <td className="text-start">
                                  <div className="mb-2">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      value={item.subtitle}
                                      name={`paragraphs[${item}].subtitle`}
                                      onChange={(e) => {
                                        updateSubtitleHandler(
                                          item,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  </div>
                                </td>
                                <td>
                                  <textarea
                                    className="form-control"
                                    name={`paragraphs[${item}].content`}
                                    value={item.content}
                                    onChange={(e) => {
                                      updateContentHandler(
                                        item,
                                        e.target.value
                                      );
                                    }}
                                    rows="10"
                                    cols="20"
                                  />
                                </td>
                                <td>
                                  <Input
                                    type="file"
                                    className="form-control"
                                    name={`paragraphs[${item}].paragraph_pic`}
                                    accept="image/jpeg,image/png,image/webp"
                                    capture="file"
                                    onChange={(e) => {
                                      updatePhotoHandler(
                                        item,
                                        e.target.files[0]
                                      );
                                    }}
                                  />
                                  <br></br>
                                  {item.paragraph_pic ? (
                                    <img
                                      src={URL.createObjectURL(
                                        item.paragraph_pic
                                      )}
                                      style={{ maxWidth: "50%" }}
                                      alt={`Thumbnail`}
                                    />
                                  ) : null}
                                </td>
                                <td
                                  id={`product-removal-${item.id}`}
                                  className="product-removal"
                                >
                                  <Link
                                    id={`del-${item.id}`}
                                    to="#"
                                    className="btn btn-danger"
                                    onClick={() => {
                                      removeItemInLocal(item);
                                    }}
                                  >
                                    {props.t("Supprimer")}
                                  </Link>
                                </td>
                              </tr>
                            </tbody>
                          </React.Fragment>
                        );
                      })}
                      <tfoot>
                        <tr>
                          <td colSpan="5">
                            <Link
                              to="#"
                              className="btn btn-soft-success fw-medium"
                              id="add-item"
                              onClick={addItem}
                            >
                              <i className="ri-add-fill me-1 align-bottom"></i>{" "}
                              {props.t("Ajouter un paragraphe")}
                            </Link>
                          </td>
                        </tr>
                      </tfoot>
                    </Table>
                  </div>
                  <div className="hstack gap-2 justify-content-end d-print-none mt-4">
                    <button
                      type="submit"
                      className="btn btn-warning"
                      disabled={
                        isLoading ||
                        updateArticleMutation.isPending ||
                        deleteParagraphMutation.isPending
                      }
                    >
                      <i className=" align-bottom me-1"></i>{" "}
                      {props.t("Modifier")}
                    </button>
                  </div>
                </CardBody>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

ArticlesUpdate.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(ArticlesUpdate));
